import React, { Component } from 'react'
import styled from 'styled-components'
import { get } from 'lodash'
import { Toast, ActivityIndicator } from 'antd-mobile'

export default class BirthdayBlessing extends Component {

  state = { isLoadding: false }

  btnClick = () => {
    this.setState({ isLoadding: true })
    const mutate = this.props.receiveBirthdayPresent
    mutate({
      variables: { patientId: get(this.props, 'match.params.patientId'), },
    })
      .then(res => {
        this.setState({ isLoadding: false })
        if (get(res, 'data.birthdayPresent')) {
          Toast.success('礼品领取成功！', 2)
        } else {
          Toast.info('您已领取过该奖品，请勿重复领取！', 2)
        }
      })
      .catch(e => {
        this.setState({ isLoadding: false })
        Toast.info('礼品领取失败 请重试！', 2)
        console.log('catch a error', e)
      })
  }

  render() {
    const patientInfo = get(this.props, 'birthday.patient', {})
    let genderName = '先生'
    let doctor = patientInfo && patientInfo.doctorInfo && patientInfo.doctorInfo.nickname
    const hospital = patientInfo && patientInfo.hospital && patientInfo.hospital.institutionName
    let doctorGroup = `${doctor}医生及医护团队`
    let hospitalGroup = `${hospital}共同照护团队`
    if (patientInfo) {
      if (patientInfo.gender !== 'male') {
        genderName = '女士'
      }
      if (!doctor) {
        doctorGroup = '共同照护全体医护团队'
      }
      if (!hospital) {
        hospitalGroup = '共同照护团队'
      }
    }
    return (
      <RootView style={{ backgroundImage: 'url(' + require('./images/bg-birthday.png') + ')' }}>
        <ContentText>
          <span>亲爱的{patientInfo.nickname}{genderName}：<br />&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{doctorGroup}</span>
          <ContentSpan >祝您生日快乐！这是共同照护陪伴您的第</ContentSpan>
          <ContentDaySpan>&nbsp;{patientInfo.joinDays}&nbsp;</ContentDaySpan>
          <ContentSpan>天，</ContentSpan>
          <ContentDaySpan>我们为您准备了15元礼券，</ContentDaySpan>
          <ContentSpan>愿您长命百岁、吉祥如意，我们会始终如一守护着您~<br /></ContentSpan>
          <ContentSpan style={{ display: 'block', textAlign: 'right', width: '100%' }}>{hospitalGroup}</ContentSpan>
        </ContentText>
        {
          this.state.isLoadding &&
          <ActivityIndicator
            toast
            text="Loading..."
            animating={this.state.animating}
          />
        }
        <ButtonBox>
          <BgImage
            src={require('./images/btn-birthday.png')}
            onClick={() => { this.btnClick() }}
          />
        </ButtonBox>
      </RootView>
    )
  }
}

const RootView = styled.div`
  width: 100%;
  height: 1500px;
  background-size: 100% 100%;
  background-repeat: no-repeat;
  position: relative;
`
const ContentText = styled.div`
  margin: 0 25px;
  position: absolute;
  top: 630px;
  left: 0px;
  color:rgb(88,36,25);
  font-size: 24px;
  font-weight: bold;
  line-height: 50px;
`
const ContentSpan = styled.span`
  color: rgb(118,79,72);
  font-size: 20px;
  line-height: 40px;
`
const ContentDaySpan = styled.span`
  color: rgb(223,145,98);
  font-size: 22px;
  line-height: 40px;
`
const ButtonBox = styled.div`
  width: 80%;
  height: 60px;
  position: absolute;
  top: 1030px;
  left: 10%;
  border-radius: 10px;
  text-align: center;
  line-height: 50px;
`
const BgImage = styled.img`
  width:100%;
  height: 100%;
`



// WEBPACK FOOTER //
// ./src/modules/birthday/components/index.js